import React from 'react';
import Keycloak from 'keycloak-js';
import { AuthClientInitOptions } from '@react-keycloak/core';
import { useKeycloak } from '@react-keycloak/web';
import ConfigKeycloak from '../keycloak.json';
import SplashScreen from '../components/layout/SplashScreen';

interface IIsKeycloakInitialized {
  children?: React.ReactNode;
}

// Singleton pattern para evitar múltiplas instâncias do Keycloak
// Usa window.keycloakInstance para persistir através de HMR (Hot Module Replacement)
declare global {
  interface Window {
    keycloakInstance?: Keycloak;
    keycloakInitialized?: boolean;
  }
}

const getKeycloakInstance = (): Keycloak => {
  if (!window.keycloakInstance) {
    const instance = new Keycloak({
      url: process.env.REACT_APP_SSO_URL ?? ConfigKeycloak['auth-server-url'],
      realm: ConfigKeycloak.realm,
      clientId: ConfigKeycloak.resource,
    });

    // Sobrescrever o método init para prevenir múltiplas inicializações
    const originalInit = instance.init.bind(instance);
    instance.init = (initOptions?: any) => {
      if (window.keycloakInitialized) {
        console.warn(
          'Keycloak already initialized, skipping re-initialization',
        );
        return Promise.resolve(instance.authenticated || false);
      }
      window.keycloakInitialized = true;
      return originalInit(initOptions);
    };

    window.keycloakInstance = instance;
  }
  return window.keycloakInstance;
};

export const keycloakInstance = getKeycloakInstance();

export const keycloakConfig: AuthClientInitOptions = {
  onLoad: 'check-sso',
  checkLoginIframe: false,
};

export const IsKeycloakInitialized: React.FC<IIsKeycloakInitialized> = ({
  children,
}) => {
  const { initialized } = useKeycloak();
  // ReactKeycloakProvider (App.tsx, autoRefreshToken) ja registra
  // keycloak.onTokenExpired -> updateToken(5) internamente. Um segundo
  // handler aqui sobrescrevia esse registro com minValidity=600 (10min) —
  // maior que a validade real do access token do realm, entao TODO refresh
  // era considerado "ja expirado" e disparava outro refresh imediato,
  // entrando em loop (rede saturada de POST /token, tela presa no splash).
  return !initialized ? <SplashScreen /> : <>{children}</>;
};

export const userCategories = {
  master: 'master',
  admin: 'admin',
  member: 'member',
  partner: 'partner',
};

export const userLevels = {
  system: 'system',
  client: 'client',
  partner: 'partner',
  vendor: 'vendor',
};
